const INCLUDE_PROPERTIES = 'LeadTechnician,CustomerAccounts.AppUser';

export const CUSTOMER_PARAMS = {
    includeProperties: INCLUDE_PROPERTIES,
};
